import { defineMessages } from 'react-intl';

export default defineMessages({
    pleaseSelectAccount: {
        id: 'twia.managepaymentmethods.Please Select Account',
        defaultMessage: 'Please Select Account '
    },
	pleaseSelect: {
		id: 'twia.managepaymentmethods.-- Please Select --',
		defaultMessage: 'twia.managepaymentmethods.-- Please Select --'
	},
	ok: {
		id: 'twia.managementpaymentmethods.payments.ok',
		defaultMessage: 'Ok'
	}
});